export { default } from './FormAudioguide.vue'
